import React, { useContext, useEffect, useState } from 'react'
import BuildingsManagementContext from '../../../context/BuildingManagementContext/BuildingsManagementContext';
import { CustomModal } from '../../CustomModal/CustomModal';
import { Button, Spinner } from 'reactstrap';
import { t } from 'i18next';
import { EmptyStateOne } from '../../Empty/EmptyStateOne';
import { ListOfBuildings } from './ListOfBuildings';
import errorIcon from '../../../assets/icons/triangule-exclamation.svg';
import buildingSuccessIcon from '../../../assets/icons/building-success-icon.svg';
import { getCurrentItems } from '../../../helpers/helpers';
import CustomPagination from '../../CustomPagination/CustomPagination';
import { BuildingSearcher } from './BuildingSearcher';

export const BuildingsManagement = () => {

    const { buildingsManagementState, getBuildingsManagement, cleanBuildingState, deleteBuilding } = useContext(BuildingsManagementContext);
    const { buildingsToConfig, responseBuildingService, isFetching } = buildingsManagementState;

    const [options, setOptions] = useState([]);

    const [showWarningModalToDelete, setShowWarningModalToDelete] = useState({
        active: false,
        building: {}
    });

    const [pageNumber, setPageNumber] = useState(1);

    const itemsPerPage = 10;

    const currentBuildings = getCurrentItems(options, pageNumber, itemsPerPage)

    const totalPages = Math.ceil(options.length / itemsPerPage);

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
    };

    const handleChangeSearchText = async (value) => {
        if (buildingsToConfig.length) {
            value = value.toLowerCase();

            const filteredObjects = buildingsToConfig.filter((opt) => {
                return opt.buildingDescription.toLowerCase().includes(value) || opt.buildingCode.toLowerCase().includes(value) || opt.Opening?.description.toLowerCase().includes(value);
            });

            setOptions(filteredObjects);
        }
    }

    const openWarningModalToDelete = (building) => setShowWarningModalToDelete({ active: true, building: building });
    const closeWarningModalToDelete = async () => setShowWarningModalToDelete({ active: false, building: {} });

    const deleteBuildingAndRefresh = async () => {
        closeWarningModalToDelete();
        await deleteBuilding(showWarningModalToDelete.building.buildingId);
    }

    const undertoodAndRefresh = async () => await getBuildingsManagement();

    useEffect(() => {
        getBuildingsManagement();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setOptions(buildingsToConfig);
        cleanBuildingState();
        // eslint-disable-next-line
    }, [buildingsToConfig]);

    return (
        <>

            <CustomModal showModal={responseBuildingService.show} centered={true} setShowModal={undertoodAndRefresh}>
                <div className='d-flex flex-column align-items-center justify-content-center'>
                    <img src={responseBuildingService.type === 'ERROR' ? errorIcon : buildingSuccessIcon} alt="" />
                    <p className='mt-3 text-center param-section-title'>{responseBuildingService.text}</p>
                    <p type="button" className='custom-modal-btn-ok' onClick={undertoodAndRefresh}>{t('UNDERSTOOD')}</p>
                </div>
            </CustomModal>

            <CustomModal showModal={showWarningModalToDelete.active} centered={true} setShowModal={closeWarningModalToDelete}>
                <div className='d-flex flex-column align-items-center justify-content-center'>
                    <img src={errorIcon} alt="" />
                    <p className='mt-3 text-center param-section-title'>{`${t('ARE_YOU_SURE_DELETE')} ${showWarningModalToDelete.building.buildingCode} - ${showWarningModalToDelete.building.buildingDescription} ?`}</p>
                </div>
                <div className='d-flex align-items-center justify-content-around'>
                    <div>
                        <p type='button' className='m-0' onClick={() => closeWarningModalToDelete()}>{t('CANCEL')}</p>
                    </div>
                    <div>
                        <Button style={{ color: '#FFFF' }} className='btn-danger' onClick={() => deleteBuildingAndRefresh()}>
                            {t('DELETE')}
                        </Button>
                    </div>
                </div>
            </CustomModal >

            <BuildingSearcher handleChangeSearchText={handleChangeSearchText} />

            {isFetching ?
                <div className="d-flex mt-4 justify-content-center">
                    <Spinner />
                </div>

                :

                <div className='itemsList'>
                    {
                        currentBuildings.length ?
                            currentBuildings.map((building, i) => {
                                return (
                                    <div key={i} className='mb-2'>
                                        <ListOfBuildings
                                            building={building}
                                            openWarningModalToDelete={openWarningModalToDelete}
                                        />
                                    </div>
                                )
                            })
                            : <div><EmptyStateOne message={t('NO_DATA_SEARCH')} /></div>
                    }
                </div>
            }

            <div className="d-flex justify-content-center">
                <CustomPagination
                    totalPages={totalPages}
                    page={pageNumber}
                    setPage={handlePageChange}
                />
            </div>
        </>
    )
}
